import { apiGet } from '../../api'

export const get_recruitee = query => {
  return apiGet({
    endpoint: `recruitment/get_recruitee?learner_id=${query}`
  })
}
